<template>
    <div>
      <button @click="login">Login </button>
      
    </div>
  </template>
  <script>
    import { useAuth0 } from '@auth0/auth0-vue';
    
  
    export default {
      setup() {
        const { loginWithRedirect } = useAuth0();
  
        return {
          login: () => {
            loginWithRedirect();
          }
        };
      }
    };
  </script>
  <style>
button{
  background-color: #000000;
    color: #fff;
    width: 150%;
    padding: 25%;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

</style>